import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }

import { MedKitSearch } from '@bigpicturemedical/medkit'
import { DvCodedTextList, DvCodedTextFilter, IPath } from '@bigpicturemedical/openehr-vue'
import { PropType } from 'vue'
import BlockHeader from './_layout/BlockHeader.vue'
import BlockPanel from './_layout/BlockPanel.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ManagementPlanBlock',
  props: {
  path: {
    type: Object as PropType<IPath>,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  errors: {
    type: Array as PropType<Array<string>>,
    default: () => [],
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BlockHeader, null, {
      heading: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.name), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.description), 1)
      ]),
      _: 1
    }),
    _createVNode(BlockPanel, { class: "p-6 space-y-4" }, {
      default: _withCtx(() => [
        _createVNode(_unref(DvCodedTextList), {
          path: __props.path.add('recommendation')
        }, {
          default: _withCtx(({ name, values, setValues, items, errors, validate, required }) => [
            _createVNode(_unref(DvCodedTextFilter), { items: items }, {
              default: _withCtx(({ filter, results }) => [
                _createVNode(_unref(MedKitSearch), {
                  multiple: "",
                  "model-value": values.map(value => ({
              label: value['|value'],
              value: value,
            })),
                  error: errors[0],
                  label: name,
                  "min-search-length": 1,
                  options: results.map(result => ({
              label: result['|value'],
              value: result
            })),
                  required: required,
                  "onUpdate:query": filter,
                  "onUpdate:modelValue": ($event: any) => (setValues($event.map(value => value.value))),
                  onInput: validate
                }, null, 8, ["model-value", "error", "label", "options", "required", "onUpdate:query", "onUpdate:modelValue", "onInput"])
              ]),
              _: 2
            }, 1032, ["items"])
          ]),
          _: 1
        }, 8, ["path"])
      ]),
      _: 1
    })
  ]))
}
}

})